<div class="dialog-footer" *ngIf="!customContent; else customFooterContent">
  <div class="dialog-footer__actions">
    <wlcm-button
      *ngIf="config.hasSecondaryButton"
      class="dialog-secondary-button"
      type="borderless"
      (clicked)="secondaryButtonClicked.emit()"
    >
    <span class="fs16 gus-font-semi-bold gus-cursor-pointer text-transform-uppercase gus-color-blue-dark">
      {{ config.secondaryButtonText }}
    </span>
      
    </wlcm-button>

    <wlcm-button class="design-button" *ngIf="config.hasPrimaryButton" (clicked)="primaryButtonClicked.emit()" [isLoading]="isLoading">
      {{ config.primaryButtonText }}
    </wlcm-button>
  </div>
</div>

<ng-template #customFooterContent>
  <ng-content select="[gusCustomDialogContent]"></ng-content>
</ng-template>
